/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsdeletebody2Inputs */

const en_ticketsdeletebody2 = /** @type {(inputs: Ticketsdeletebody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the ticket type already has orders, it is only taken off sale. Tickets already sold stay valid.`)
};

const de_ticketsdeletebody2 = /** @type {(inputs: Ticketsdeletebody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hat die Ticketart schon Bestellungen, nehmen wir sie nur aus dem Verkauf. Verkaufte Tickets bleiben gültig.`)
};

/**
* | output |
* | --- |
* | "If the ticket type already has orders, it is only taken off sale. Tickets already sold stay valid." |
*
* @param {Ticketsdeletebody2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsdeletebody2 = /** @type {((inputs?: Ticketsdeletebody2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsdeletebody2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsdeletebody2(inputs)
	return de_ticketsdeletebody2(inputs)
});
export { ticketsdeletebody2 as "ticketsDeleteBody" }